import { useUtilizationReportFilterOptionsQuery } from "@src/__generated__/graphql";
import { UtilizationReportWhereColumn } from "@src/__generated__/urql-graphql";
import type { UtilizationReportBaseStore } from "@src/components/modules/reports/utilization/stores/base-store";
import mapToOptions from "@src/utils/map-to-options";
import { useEffect } from "react";

export function useUtilizationOptions(store: UtilizationReportBaseStore) {
  const { data } = useUtilizationReportFilterOptionsQuery();

  useEffect(() => {
    if (!data) return;
    store.where.filtersByColumn
      .get(UtilizationReportWhereColumn.TeamId)
      ?.setOptions(mapToOptions.teams(data.teamSimpleMap));

    store.where.filtersByColumn
      .get(UtilizationReportWhereColumn.WorkTypeId)
      ?.setOptions(mapToOptions.workTypes(data.timeTrackingWorkTypes));

    store.where.filtersByColumn
      .get(UtilizationReportWhereColumn.UserId)
      ?.setOptions(mapToOptions.users(data.userSimpleMap));
  }, [data]);
}
